import { AccountMobile } from '@wize-mobile-api';
import { Account, AccountTypeEnum } from '@qvs/core';

export class AccountMapper {
  public static fromWizeAccounts = (accounts: AccountMobile[]): Account[] =>
    accounts.map((account) => {
      const { typeValue, ...rest } = account;
      return {
        type: AccountTypeEnum[typeValue],
        ...rest,
        totalInPortfolioCurrency: {
          value: account.currentBalance,
          currency: account.currencyId
        },
        accountTypeId: account.accountTypeId
      };
    });
}
